import React, { useEffect, useState } from 'react';
import MyDiv from './payrollCard.style';
import { Box, Flex, Text, Divider, Button, Popover, PopoverTrigger, PopoverContent, PopoverBody, useDisclosure, Center, Spinner, } from '@chakra-ui/react';
import { CalendarIcon } from '@chakra-ui/icons';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { BarChart, Bar, XAxis, Tooltip, ResponsiveContainer, } from "recharts";
import { CustomToast } from '../../../../components';
import { useFetch } from '../../../../hooks/useFetch';




const CustomTooltip = ({ active, payload, label }: any) => {
  if (active && payload && payload.length) {
    const order = ["Payroll Process", "Pending Process",];
    const sortedPayload = [...payload].sort(
      (a, b) => order.indexOf(a.name) - order.indexOf(b.name)
    );

    return (
      <Box className="tooltip">
        <Box className="text">
          <Text className="font-poppins text_semibold text_lg">{label}</Text>
        </Box>
        <Box p={3}>
          {sortedPayload.map((item: any) => (
            <Flex key={item.dataKey} align="center" mb={1}>
              <Box w="15px" h="15px" borderRadius="full" bg={item.fill} mr={2} />
              <Text className="font-poppins text_medium text_md">
                {item.value} <Text as={"span"} color="grey">{item.name}</Text>
              </Text>
            </Flex>
          ))}
        </Box>
      </Box>
    );
  }
  return null;
};

const PayrollCard = ({ branch }: { branch: number[] }) => {
  let date = new Date();
  date.setMonth(date.getMonth() - 1);
  const { addToast } = CustomToast();
  const { fetchApi, loading } = useFetch(addToast);
  const [selectedDate, setSelectedDate] = useState(date);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [chartData, setChartData] = useState<any[]>([]);

  const formatMonthYear = (date: Date) =>
    date.toLocaleString('default', { month: 'long', year: 'numeric' });

  const formatDate = (date: Date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };


  const loadPayrollBranchWise = async () => {
    const formattedDate = selectedDate ? formatDate(selectedDate) : "";
    const params = new URLSearchParams();
    params.append("date", formattedDate);

    if (branch.length > 0) {
      branch.forEach((b) => params.append("branch", b.toString()));
    } else {
      params.append("branch", "0"); // all branches
    }
 
    console.log(params.toString());
    const response = await fetchApi("Dashboard/branchWisePayroll", "GET", "", params.toString(), "");
    if (response) {
      setChartData(response);
    }
  };

  useEffect(() => {
    loadPayrollBranchWise();
  }, [branch, selectedDate])




  return (
    <MyDiv>
      <Box className="card-wrapper common_bg" >
        <Box className="card" p={4}>
          <Flex justify="space-between" align="center" mb={2}>
            <Text className="font-poppins text_md text_semibold">Payroll Processed</Text>
            <Popover isOpen={isOpen} onOpen={onOpen} onClose={onClose} placement="bottom-end">
              <PopoverTrigger>
                <Button leftIcon={<CalendarIcon />} padding={3} variant="outline">
                  <Text className="font-poppins text_sm text_regular">
                    {formatMonthYear(selectedDate)}
                  </Text>
                </Button>
              </PopoverTrigger>
              <PopoverContent w="auto">
                <PopoverBody p={2} display="flex" justifyContent="center">
                  <Calendar
                    value={selectedDate}
                    onChange={(value) => {
                      if (value instanceof Date) {
                        setSelectedDate(value);
                        onClose();
                      }
                    }}
                    view="year"
                    maxDetail="year"
                    maxDate={new Date()}
                  />
                </PopoverBody>
              </PopoverContent>
            </Popover>
          </Flex>

          <Divider my={2} />
          {loading ? (
            <Center h="200px">
              <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="#006838" size="xl" />
            </Center>
          ) : chartData.length === 0 ? (
            <Center h="300px">
              <Text className="font-poppins text_md text_semibold" color="gray.500" >
                No data available
              </Text>
            </Center>
          ) : (
            <Box h="200px">
              <ResponsiveContainer>
                <BarChart data={chartData} barSize={40}>
                  <XAxis dataKey="branch" className="font-poppins text_xsm text_regular" />
                  <Tooltip content={<CustomTooltip />} />
                  <Bar dataKey="pending" stackId="a" fill="#808080" name="Pending Pending"  />
                  <Bar dataKey="released" stackId="a" fill="#008000" name="Payroll Released"  />
                   <Bar dataKey="updated" stackId="a" fill="#b6ca21" name="Payroll Updated"  />
                    <Bar dataKey="generated" stackId="a" fill="#1a2dbd" name="Payroll Generated"  radius={[20, 20, 0, 0]}/>
                </BarChart>
              </ResponsiveContainer>
            </Box>
          )}
        </Box>
      </Box>
    </MyDiv>
  );
};

export default PayrollCard;
